import { colors } from '@/constants/colors'
import { useQueryClient } from '@tanstack/react-query'
import { useFocusEffect, useLocalSearchParams } from 'expo-router'
import { useCallback } from 'react'
import { WebView } from 'react-native-webview'
import type { WebViewSourceUri } from 'react-native-webview/lib/WebViewTypes'

export default function ScheduleAppointmentModal() {
	const queryClient = useQueryClient()
	const { scheduleUrl } = useLocalSearchParams<{ scheduleUrl: string }>()

	useFocusEffect(
		useCallback(() => {
			return () => {
				queryClient.invalidateQueries({
					queryKey: ['upcoming-appointment'],
				})
			}
		}, [queryClient.invalidateQueries])
	)

	return (
		<WebView
			style={{
				backgroundColor: colors.palette_5,
				flex: 1,
			}}
			source={
				{
					uri: scheduleUrl,
				} as WebViewSourceUri
			}
			bounces={false}
		/>
	)
}
